import { sizing } from '@/styles/designTokens'
import {
	NavBarSkeleton,
	SkeletonPill,
	SearchBarRow,
	PillsRow,
	HamburgerPlaceholder,
	DesktopSpacer,
	DesktopSearchBarSkeleton,
} from './CategoryNavSkeleton.styled'

export default function CategoryNavSkeleton() {
	return (
		<NavBarSkeleton aria-hidden="true" data-testid="category-nav-skeleton">
			{/* Search bar skeleton — visible on mobile + tablet (<md) */}
			<SearchBarRow sx={{ display: { xs: 'flex', md: 'none' } }}>
				<SkeletonPill sx={{ flex: '1 0 0', height: sizing.searchBarHeight }} />
			</SearchBarRow>

			{/* Pills row */}
			<PillsRow>
				{/* Hamburger placeholder — visible on mobile + tablet (<md) */}
				<HamburgerPlaceholder sx={{ display: { xs: 'block', md: 'none' } }} />

				{sizing.skeletonPillWidths.map((w, i) => (
					<SkeletonPill
						key={i}
						sx={{
							flexShrink: 0,
							width: w,
							height: { xs: sizing.pillHeightMobile, md: sizing.pillHeightDesktop },
						}}
					/>
				))}

				{/* Desktop: spacer + search bar skeleton (≥md) */}
				<DesktopSpacer sx={{ display: { xs: 'none', md: 'flex' } }} />
				<DesktopSearchBarSkeleton sx={{ display: { xs: 'none', md: 'block' } }} />
			</PillsRow>
		</NavBarSkeleton>
	)
}
